import { ReactComponent as CircleCheck } from '@assets/icons/circle-check.svg';
import { passwordRules } from 'constant';

import {
  Box,
  BoxProps,
  Flex,
  HStack,
  List,
  ListItem,
  useTheme
} from '@chakra-ui/react';

import { Text } from 'ui';

interface PasswordRulesProps {
  password: string;
  confirmPassword: string;
  containerProps?: BoxProps;
  isAuthStep?: boolean;
}

const PasswordRules = ({
  password,
  confirmPassword,
  containerProps = {},
  isAuthStep = false
}: PasswordRulesProps) => {
  const {
    colors: {
      palette: {
        components: { passwordRules: passwordRulesColor }
      }
    }
  } = useTheme();

  return (
    <Flex w='100%' justifyContent='center' {...containerProps}>
      <Flex
        as={List}
        flexWrap='wrap'
        justifyContent='flex-start'
        flexDirection={isAuthStep ? 'column' : 'row'}
        w='100%'
        maxW={{ base: '100%', lg: '425px' }}
        bg={isAuthStep ? passwordRulesColor.reqBg : 'inherit'}
        borderRadius='6px'
        py={isAuthStep ? '16px' : 0}
        px={isAuthStep ? '24px' : 0}
      >
        {isAuthStep && (
          <Text
            ml='10px'
            mb='16px'
            textTransform='uppercase'
            fontWeight='semibold'
          >
            minimum requirements
          </Text>
        )}
        {passwordRules.map(({ title, validFunc, required }) => {
          const isValid = validFunc(password, confirmPassword);

          return (
            <HStack
              as={ListItem}
              key={title}
              w={
                isAuthStep
                  ? 'auto'
                  : { base: 'calc(50% - 20px)', md: 'calc(50% - 30px)' }
              }
              ml='10px'
              mt='5px'
              mb='6px'
              alignItems='center'
              justifyContent='start'
              gap='9px'
            >
              <Box flexShrink={0}>
                {isValid ? (
                  <CircleCheck
                    width='14px'
                    height='14px'
                    fill={passwordRulesColor.checkIconColor}
                  />
                ) : (
                  <Flex
                    alignItems='center'
                    justifyContent='center'
                    width='14px'
                    height='14px'
                    border='1px solid'
                    borderColor={passwordRulesColor.emptyIconBorderColor}
                    borderRadius='50%'
                  />
                )}
              </Box>

              <Text
                fontSize='13px'
                color={passwordRulesColor.textColor}
                as='span'
              >
                {title}{' '}
                {!required && (
                  <Text fontSize='11px' as='span'>
                    (optional)
                  </Text>
                )}
              </Text>
            </HStack>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default PasswordRules;
